// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__11fxj","header":"ReportDetails_header__15-x1","title":"ReportDetails_title__zffXl","left":"ReportDetails_left__eoICm"};